import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: _normalizeClass('main-background'),
        fullscreen: true,
        slot: "fixed",
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigate('login'))),
            class: "header-button bg-transparent"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                slot: "start",
                icon: _ctx.arrowBackOutline
              }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, { class: "bg-transparent" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, { class: "ion-text-center white-bold" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Сброс пароля", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_input, {
                    type: "email",
                    inputmode: "email",
                    placeholder: "Электронная почта",
                    modelValue: _ctx.email,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resetPassword())),
                      class: "reset-button"
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode(" OK ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}